const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    typeText(type) {
        switch (type) {
            case 'TRAINEE':
                return  __('Elevpladser');
            case 'GRADUATE':
                return  __('Graduate programmer');
            case 'JOBS':
                return  __('Ledige job');
        }
    },
    linkText(type) {
        switch (type) {
            case 'TRAINEE':
                return  __('Se elevpladser');
            case 'GRADUATE':
                return  __('Se graduate programmer');
            case 'JOBS':
                return  __('Se jobannoncer');
        }
    },
};
